module.exports = __webpack_public_path__ + "static/media/add.1d3094dc.svg";